import { STANDARD_COMPONENT_TYPES_V2 } from 'opensolar-common'
import { isSolveraComponentCode } from 'projectSections/sections/design/systems/solveraComponentCode'
import type { ComponentTypesV2 } from 'types/selectComponent'
import type { PostFetchGuard } from '../types'

type FetchedComponent = {
  code?: string
}

const isOtherComponentSelectionType = (type: ComponentTypesV2): boolean => {
  return !STANDARD_COMPONENT_TYPES_V2.includes(type as (typeof STANDARD_COMPONENT_TYPES_V2)[number])
}

/**
 * Solvera Sunshine Guarantee SKUs are added by design rules only — hide them from manual
 * component selector flows (including "Select Component" / "Select Other Components").
 */
export const solveraManualSelectionPostFetchGuard: PostFetchGuard = ({ componentsData, componentTypes }) => {
  const isOtherSelection = componentTypes?.some(isOtherComponentSelectionType)
  if (!isOtherSelection) return componentsData || []

  return (componentsData || []).filter((component: FetchedComponent) => !isSolveraComponentCode(component?.code))
}
